import { ListingCategoriesFacades } from '@components/listing-categories-facades/models';
import { ElasticSearchResponse, FrontsCategoriesDocument } from '@shared/services/elastic-search/models';

export const frontsCategoriesSerializer = (
  frontsCategories: ElasticSearchResponse<FrontsCategoriesDocument>
): ListingCategoriesFacades => ({
  frontCategories: frontsCategories.hits.hits.map((hit) => {
    const source = hit._source;
    return {
      name: source.name?.[0] ?? '',
      image: source.field_visuel?.[0] ?? '',
      costLevel: source.field_categorie_facade_prix?.[0] ?? undefined,
      url: source.field_page_link?.[0] ?? '',
    };
  }),
});
